import { Component } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared.module';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { RulesService } from 'src/app/services/api/rules.service';
import { RuleHeaderComponent } from '../rule-header/rule-header.component';

@Component({
  selector: 'app-rule-page',
  imports: [SharedModule, BreadcrumbComponent],
  templateUrl: './rule-page.component.html',
  styleUrl: './rule-page.component.scss'
})
export class RulePageComponent {

  constructor(public readonly rulesService: RulesService) { }

}
